/**
 * HTTP_COLORS are the per-method badge colors, shared across both color schemes
 * and drawn from Mantine's semantic palette so an operation reads the same
 * wherever it appears. They are handed to Redoc as its `colors.http` theme map
 * and used directly by the reference's navigation rail, so the badge beside an
 * operation in the rail is the same color as the badge on the operation itself.
 *
 * They are concrete hex strings rather than CSS variables because Redoc derives
 * shades from them internally with `polished`, which cannot resolve `var()`.
 */
export const HTTP_COLORS = {
  delete: "#fa5252",
  get: "#228be6",
  patch: "#fab005",
  post: "#40c057",
  put: "#fd7e14",
} as const;

/**
 * HttpMethod is a method the badge palette covers. A spec is free to use any
 * verb, so `colorForMethod` falls back rather than assuming membership.
 */
export type HttpMethod = keyof typeof HTTP_COLORS;

/**
 * colorForMethod resolves a method name (in any case) to its badge color,
 * falling back to a neutral gray for a verb the palette does not name, so an
 * uncommon operation still renders a badge rather than an unstyled one.
 */
export const colorForMethod = (method: string): string =>
  HTTP_COLORS[method.toLowerCase() as HttpMethod] ?? "#868e96";
